import { render, staticRenderFns } from "./NielsenTab.vue?vue&type=template&id=795c1334&scoped=true&"
import script from "./NielsenTab.vue?vue&type=script&lang=js&"
export * from "./NielsenTab.vue?vue&type=script&lang=js&"
import style0 from "./NielsenTab.vue?vue&type=style&index=0&id=795c1334&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "795c1334",
  null
  
)

export default component.exports
import {QForm,QScrollArea,QInput} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QForm,QScrollArea,QInput})
